import React from "react";
import styles from "./accessDenied.module.scss";
import { withTranslation } from "react-i18next";
import FordLogo from "../../common/FordLogo";

const InvalidRoute = (props) => {
  return (
    <div className="pageWrapper">
      <div className={styles.center}>
        <FordLogo className={styles.brandLogo} />
        <div className={styles.deniedTitle}>
          {props.t("InvalidRoute.header")}
        </div>
      </div>
    </div>
  );
};

export default withTranslation("emp")(InvalidRoute);
